import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ViewBannerModal = ({ show, handleClose, banner }) => {
    if (!banner) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View Banner Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <strong>Banner ID:</strong> {banner.id}
                </div>
                <div className="mb-3">
                    <strong>Project ID:</strong> {banner.project_id || "N/A"}
                </div>
                <div className="mb-3">
                    <strong>Nickname:</strong> {banner.nickname}
                </div>
                <div className="mb-3">
                    <strong>Image:</strong>
                    <img
                        src={banner.image_path}
                        alt={banner.nickname}
                        style={{ maxWidth: '100%', maxHeight: '300px' }}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewBannerModal;